module.exports = __webpack_public_path__ + "img/address-empty.9c0aec03.svg";